import GridViewIcon from '@mui/icons-material/GridView';
import SearchIcon from '@mui/icons-material/Search';
import ViewListIcon from '@mui/icons-material/ViewList';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Toolbar } from 'react-admin';
import { Search, SearchIconWrapper, StyledInputBase } from '../../common/Search';
import { useFileManagerModalInputDialogContentContext } from './FileManagerModalInputDialogContentProvider';
import FileManagerModalInputDialogList from './FileManagerModalInputDialogList';
import FileManagerModalInputDialogUpload from './FileManagerModalInputDialogUpload';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import FileManagerModalInputDialogListBreadcrumb from './FileManagerModalInputDialogListBreadcrumb';

interface FileManagerModalInputDialogProps {
  source?: string,
}

export const FileManagerModalInputDialog = ({ source, ...props }: FileManagerModalInputDialogProps) => {
  const { groups, group, setGroup, search, setSearch, setSub, isThumbnailView, setIsThumbnailView } = useFileManagerModalInputDialogContentContext();
  const formContext = useFormContext();
  const { watch } = formContext ? formContext : { watch: (source: string) => null };
  const value = source ? watch(source) : null;

  useEffect(() => {
    if (value && value.group) {
      setGroup(value.group);
    }
    if (value && value.sub) {
      setSub(value.sub);
    }
  }, [value, setGroup, setSub]);

  // console.log(group);
  return (
    <Box sx={{ width: '100%', height: '90vh' }}>
      <Toolbar>
        <ToggleButtonGroup>
          {groups.map((loopGroupItem) => (
            <ToggleButton key={loopGroupItem.group} onClick={() => {
              setGroup(loopGroupItem.group);
              setSub([]);
            }} value={loopGroupItem.label} selected={group === loopGroupItem.group}>{loopGroupItem.label}</ToggleButton>
          ))}
        </ToggleButtonGroup>
        <span style={{ flex: 1 }}></span>
        <FormGroup>
          <FormControlLabel control={<Switch value={isThumbnailView} onChange={() => setIsThumbnailView((o: boolean) => !o)} />} label={isThumbnailView ? <ViewListIcon fontSize="large" /> : <GridViewIcon fontSize="large" />} />
        </FormGroup>
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </Search>
      </Toolbar>
      <Grid container spacing={1}>
        <Grid item xs={9}>
          <FileManagerModalInputDialogListBreadcrumb />
          <Paper sx={{ height: 'calc(90vh - 64px - 64px - 48px)', overflowY: 'scroll' }}>
            <FileManagerModalInputDialogList {...props} />
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <FileManagerModalInputDialogUpload />
        </Grid>
      </Grid>
    </Box>
  )
}
